import { atom } from 'recoil';
import { RecoilAtomKey } from '../recoilConstantKey';
// import { isMobile } from 'react-device-detect';

// const isMobileDeviceAtom = atom({
//   key: 'isMobileDeviceKey',
//   default: isMobile ? false : true,
// })

const showHideTable = atom({
  key: 'showHideTable',
  default: {
    ViewClientWise: false,
    ViewAgencyWise: false,
    ViewEndCustomerWise: false,
    ViewCityWise: false,
    ViewCampaignWise: false,
    ViewLeadDetail: false,
  },
});

const showHideBreadcrumbsAtom = atom({
  key: 'showHideBreadcrumbsAtom',
  default: {
    first: { show: false, tableName: '' },
    second: { show: false, tableName: '' },
    third: { show: false, tableName: '' },
    fourth: { show: false, tableName: '' },
  },
});

const showHideModalAtom = atom({
  key: 'showHideModalAtom',
  default: {
    email: { show: false, tableName: '' },
    whatsapp: { show: false, tableName: '' },
    leadDetail: { show: false, tableName: '' },
    comment: { show: false, tableName: '' },
    download: { show: false, tableName: '' },
  },
});

// const OrganisationListAtom = atom({
//   key: RecoilAtomKey.organisationListKey,
//   default: [],
// });

const UserMinimalListAtom = atom({
  key: RecoilAtomKey.userMinimalListKey,
  default: [],
});

const stateListAtom = atom({
  key: RecoilAtomKey.stateListKey,
  default: [],
});

export {
  showHideTable,
  showHideBreadcrumbsAtom,
  showHideModalAtom,
  UserMinimalListAtom,
  stateListAtom,
  // isMobileDeviceAtom,
};
